let status = false;

function setValue(value) {
  status = value;
}

function getValue() {
  return status;
}

const movingAnnotations = {
  setValue,
  getValue,
};

export default movingAnnotations;
